"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimes = void 0;
const getTimes = (intervalInMinutes = 60, mode = 12) => {
    const AM_PM = ['AM', 'PM'];
    let startTime = 0;
    const count = Math.round((24 * 60) / intervalInMinutes);
    return new Array(count).fill('').map(() => {
        const hh = Math.floor(startTime / 60);
        const mm = startTime % 60;
        const hour = `0${hh}`.slice(-2);
        const hourAmPm = `0${hh % 12 || 12}`.slice(-2);
        const minute = `0${mm}`.slice(-2);
        const amPm = AM_PM[Math.floor(hh / 12)];
        startTime += intervalInMinutes;
        return mode === 12 ? `${hourAmPm}:${minute} ${amPm}` : `${hour}:${minute}`;
    });
};
exports.getTimes = getTimes;
//# sourceMappingURL=getTimes.js.map